import React, { useEffect } from 'react';
import { defaultImages } from '../constants';
import EventTab from '../ui/eventTabs';
import { Toaster } from 'react-hot-toast';
import { removeSessionItem } from '../constants';

function EventList() {
  useEffect(() => {
    //this code is to remove saved box-seat details which were saved when user refreshes the watch event screen
    removeSessionItem('prevBoxSeatDetails');
  });

  return (
    <>
      <EventTab image={defaultImages.logo} />
      <Toaster position="top-center" />
    </>
  );
}

export default EventList;
